// extracted by mini-css-extract-plugin
export default {"attachment__hidden":"KnUdV","attachment__container":"kWX3b"};